import React, { Fragment } from 'react';

function Footer() {
	return (
		<Fragment>
		<footer>
			<p>Updated: Sep, 2026</p>
		</footer>
		</Fragment>
	)
}

export { Footer }